import { mapActions } from 'vuex'
import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
import AuthLayout from 'src/views/Layouts/AuthLayout.vue'

const mixinAuth = {
    components: {
        LCheckbox,
        FadeRenderTransition,
        AuthLayout,
    },
    data () {
        return {
        // datos de usuario
        user: {
            login: '',
            password: '',
          },
          // mostrar/ocultar pass
          showPass: {
            inputTypePass: 'password',
            inputTypePass2: 'password',
            iconBtnPass: 'fa fa-eye',
            iconBtnPass2: 'fa fa-eye',
          },
          // validar usuario
          modelValidations: {
            login: {
              required: true,
            },
            password: {
              required: true,
              min: 8
            }
          },
          btnDisabled: false,
        }
    },
    methods: {
        // mapeamos las acciones de nuestro store para poder llamarlas desde este script
        ...mapActions({
          login: 'auth/login',
          loginGoogle: 'auth/loginGoogle',
          passwordRequest: 'auth/passwordRequest',
          passwordReset: 'auth/passwordReset',
        }),

        getError (fieldName) {
            return this.errors.first(fieldName)
        },

        validateKey () {
            this.$validator.validateAll().then(isValid => {
              if (isValid) {
                this.btnDisabled = false
              } else {
                this.btnDisabled = true
              }
            })
        },

        toggleNavbar () {
            document.body.classList.toggle('nav-open')
        },

        closeMenu () {
          document.body.classList.remove('nav-open')
          document.body.classList.remove('off-canvas-sidebar')
        },

        // este metodo permite mostrar/ocultar la contraseña en el formulario
        showPassword() {
          if(this.showPass.inputTypePass === 'password') {
            this.showPass.iconBtnPass = 'fa fa-eye-slash'
            this.showPass.inputTypePass = 'text'
          } else {
            this.showPass.iconBtnPass = 'fa fa-eye'
            this.showPass.inputTypePass = 'password'
          }
        },
    },
    beforeDestroy () {
      this.closeMenu()
    }
}

export default mixinAuth
